import { render, staticRenderFns } from "./CoachRequests.vue?vue&type=template&id=bbd9d8da&scoped=true&"
import script from "./CoachRequests.vue?vue&type=script&lang=js&"
export * from "./CoachRequests.vue?vue&type=script&lang=js&"
import style0 from "./CoachRequests.vue?vue&type=style&index=0&id=bbd9d8da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd9d8da",
  null
  
)

export default component.exports